/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AppleHealthSyncResponseDto } from '../model';
// @ts-ignore
import type { ConnectGarminDto } from '../model';
// @ts-ignore
import type { ConnectStravaDto } from '../model';
// @ts-ignore
import type { GarminConnectionResponseDto } from '../model';
// @ts-ignore
import type { GarminDisconnectResponseDto } from '../model';
// @ts-ignore
import type { GarminPermissionsResponseDto } from '../model';
// @ts-ignore
import type { GarminSyncResponseDto } from '../model';
// @ts-ignore
import type { GarminWebhookPermissionsDto } from '../model';
// @ts-ignore
import type { GarminWebhookUserDeregDto } from '../model';
// @ts-ignore
import type { RegisterFcmTokenDto } from '../model';
// @ts-ignore
import type { RemoveFcmTokenDto } from '../model';
// @ts-ignore
import type { StravaConnectionResponseDto } from '../model';
// @ts-ignore
import type { StravaDisconnectResponseDto } from '../model';
// @ts-ignore
import type { StravaSyncResponseDto } from '../model';
// @ts-ignore
import type { SyncAppleHealthActivitiesDto } from '../model';
// @ts-ignore
import type { SyncGarminActivitiesDto } from '../model';
// @ts-ignore
import type { SyncStravaActivitiesDto } from '../model';
// @ts-ignore
import type { UpdateUserDto } from '../model';
// @ts-ignore
import type { UserDto } from '../model';
// @ts-ignore
import type { UsersControllerDeleteAccount200Response } from '../model';
/**
 * UsersApi - axios parameter creator
 * @export
 */
export const UsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Connect user to Garmin and sync initial activities
         * @param {ConnectGarminDto} connectGarminDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerConnectGarmin: async (connectGarminDto: ConnectGarminDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'connectGarminDto' is not null or undefined
            assertParamExists('usersControllerConnectGarmin', 'connectGarminDto', connectGarminDto)
            const localVarPath = `/api/users/garmin/connect`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(connectGarminDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Connect user to Strava and sync initial activities
         * @param {ConnectStravaDto} connectStravaDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerConnectStrava: async (connectStravaDto: ConnectStravaDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'connectStravaDto' is not null or undefined
            assertParamExists('usersControllerConnectStrava', 'connectStravaDto', connectStravaDto)
            const localVarPath = `/api/users/strava/connect`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(connectStravaDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete current user account (soft delete)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerDeleteAccount: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Disconnect user from Garmin (preserve existing activities)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerDisconnectGarmin: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/garmin/disconnect`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Disconnect user from Strava (preserve existing activities)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerDisconnectStrava: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/strava/disconnect`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get current authenticated user profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerGetCurrentUser: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Garmin permissions for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerGetGarminPermissions: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/garmin/permissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Garmin webhook for user permission changes
         * @param {GarminWebhookPermissionsDto} garminWebhookPermissionsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerHandleGarminPermissionsWebhook: async (garminWebhookPermissionsDto: GarminWebhookPermissionsDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'garminWebhookPermissionsDto' is not null or undefined
            assertParamExists('usersControllerHandleGarminPermissionsWebhook', 'garminWebhookPermissionsDto', garminWebhookPermissionsDto)
            const localVarPath = `/api/users/garmin/webhook/permissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(garminWebhookPermissionsDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Garmin ping verification for user dereg webhook
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerHandleGarminUserDeregPing: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/garmin/webhook/user-dereg`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Garmin webhook for user deregistration
         * @param {GarminWebhookUserDeregDto} garminWebhookUserDeregDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerHandleGarminUserDeregWebhook: async (garminWebhookUserDeregDto: GarminWebhookUserDeregDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'garminWebhookUserDeregDto' is not null or undefined
            assertParamExists('usersControllerHandleGarminUserDeregWebhook', 'garminWebhookUserDeregDto', garminWebhookUserDeregDto)
            const localVarPath = `/api/users/garmin/webhook/user-dereg`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(garminWebhookUserDeregDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Register FCM token for push notifications
         * @param {RegisterFcmTokenDto} registerFcmTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerRegisterFcmToken: async (registerFcmTokenDto: RegisterFcmTokenDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'registerFcmTokenDto' is not null or undefined
            assertParamExists('usersControllerRegisterFcmToken', 'registerFcmTokenDto', registerFcmTokenDto)
            const localVarPath = `/api/users/fcm-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(registerFcmTokenDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Remove FCM token from user
         * @param {RemoveFcmTokenDto} removeFcmTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerRemoveFcmToken: async (removeFcmTokenDto: RemoveFcmTokenDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'removeFcmTokenDto' is not null or undefined
            assertParamExists('usersControllerRemoveFcmToken', 'removeFcmTokenDto', removeFcmTokenDto)
            const localVarPath = `/api/users/fcm-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(removeFcmTokenDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sync Apple Health activities from client-provided workout samples
         * @param {SyncAppleHealthActivitiesDto} syncAppleHealthActivitiesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerSyncAppleHealthActivities: async (syncAppleHealthActivitiesDto: SyncAppleHealthActivitiesDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'syncAppleHealthActivitiesDto' is not null or undefined
            assertParamExists('usersControllerSyncAppleHealthActivities', 'syncAppleHealthActivitiesDto', syncAppleHealthActivitiesDto)
            const localVarPath = `/api/users/apple-health/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(syncAppleHealthActivitiesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Manually sync Garmin activities
         * @param {SyncGarminActivitiesDto} syncGarminActivitiesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerSyncGarminActivities: async (syncGarminActivitiesDto: SyncGarminActivitiesDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'syncGarminActivitiesDto' is not null or undefined
            assertParamExists('usersControllerSyncGarminActivities', 'syncGarminActivitiesDto', syncGarminActivitiesDto)
            const localVarPath = `/api/users/garmin/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(syncGarminActivitiesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Manually sync Strava activities
         * @param {SyncStravaActivitiesDto} syncStravaActivitiesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerSyncStravaActivities: async (syncStravaActivitiesDto: SyncStravaActivitiesDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'syncStravaActivitiesDto' is not null or undefined
            assertParamExists('usersControllerSyncStravaActivities', 'syncStravaActivitiesDto', syncStravaActivitiesDto)
            const localVarPath = `/api/users/strava/sync`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(syncStravaActivitiesDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update user by ID
         * @param {UpdateUserDto} updateUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerUpdate: async (updateUserDto: UpdateUserDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateUserDto' is not null or undefined
            assertParamExists('usersControllerUpdate', 'updateUserDto', updateUserDto)
            const localVarPath = `/api/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UsersApi - functional programming interface
 * @export
 */
export const UsersApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UsersApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Connect user to Garmin and sync initial activities
         * @param {ConnectGarminDto} connectGarminDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerConnectGarmin(connectGarminDto: ConnectGarminDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GarminConnectionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerConnectGarmin(connectGarminDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersControllerConnectGarmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Connect user to Strava and sync initial activities
         * @param {ConnectStravaDto} connectStravaDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerConnectStrava(connectStravaDto: ConnectStravaDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StravaConnectionResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerConnectStrava(connectStravaDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersControllerConnectStrava']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete current user account (soft delete)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerDeleteAccount(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UsersControllerDeleteAccount200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerDeleteAccount(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersControllerDeleteAccount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Disconnect user from Garmin (preserve existing activities)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerDisconnectGarmin(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GarminDisconnectResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerDisconnectGarmin(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersControllerDisconnectGarmin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Disconnect user from Strava (preserve existing activities)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerDisconnectStrava(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StravaDisconnectResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerDisconnectStrava(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersControllerDisconnectStrava']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get current authenticated user profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerGetCurrentUser(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerGetCurrentUser(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersControllerGetCurrentUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Garmin permissions for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerGetGarminPermissions(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GarminPermissionsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerGetGarminPermissions(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersControllerGetGarminPermissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Garmin webhook for user permission changes
         * @param {GarminWebhookPermissionsDto} garminWebhookPermissionsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerHandleGarminPermissionsWebhook(garminWebhookPermissionsDto: GarminWebhookPermissionsDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerHandleGarminPermissionsWebhook(garminWebhookPermissionsDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersControllerHandleGarminPermissionsWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Garmin ping verification for user dereg webhook
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerHandleGarminUserDeregPing(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerHandleGarminUserDeregPing(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersControllerHandleGarminUserDeregPing']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Garmin webhook for user deregistration
         * @param {GarminWebhookUserDeregDto} garminWebhookUserDeregDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerHandleGarminUserDeregWebhook(garminWebhookUserDeregDto: GarminWebhookUserDeregDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerHandleGarminUserDeregWebhook(garminWebhookUserDeregDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersControllerHandleGarminUserDeregWebhook']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Register FCM token for push notifications
         * @param {RegisterFcmTokenDto} registerFcmTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerRegisterFcmToken(registerFcmTokenDto: RegisterFcmTokenDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerRegisterFcmToken(registerFcmTokenDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersControllerRegisterFcmToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Remove FCM token from user
         * @param {RemoveFcmTokenDto} removeFcmTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerRemoveFcmToken(removeFcmTokenDto: RemoveFcmTokenDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerRemoveFcmToken(removeFcmTokenDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersControllerRemoveFcmToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Sync Apple Health activities from client-provided workout samples
         * @param {SyncAppleHealthActivitiesDto} syncAppleHealthActivitiesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerSyncAppleHealthActivities(syncAppleHealthActivitiesDto: SyncAppleHealthActivitiesDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AppleHealthSyncResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerSyncAppleHealthActivities(syncAppleHealthActivitiesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersControllerSyncAppleHealthActivities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Manually sync Garmin activities
         * @param {SyncGarminActivitiesDto} syncGarminActivitiesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerSyncGarminActivities(syncGarminActivitiesDto: SyncGarminActivitiesDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GarminSyncResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerSyncGarminActivities(syncGarminActivitiesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersControllerSyncGarminActivities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Manually sync Strava activities
         * @param {SyncStravaActivitiesDto} syncStravaActivitiesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerSyncStravaActivities(syncStravaActivitiesDto: SyncStravaActivitiesDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StravaSyncResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerSyncStravaActivities(syncStravaActivitiesDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersControllerSyncStravaActivities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update user by ID
         * @param {UpdateUserDto} updateUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async usersControllerUpdate(updateUserDto: UpdateUserDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.usersControllerUpdate(updateUserDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UsersApi.usersControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UsersApi - factory interface
 * @export
 */
export const UsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UsersApiFp(configuration)
    return {
        /**
         * 
         * @summary Connect user to Garmin and sync initial activities
         * @param {ConnectGarminDto} connectGarminDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerConnectGarmin(connectGarminDto: ConnectGarminDto, options?: RawAxiosRequestConfig): AxiosPromise<GarminConnectionResponseDto> {
            return localVarFp.usersControllerConnectGarmin(connectGarminDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Connect user to Strava and sync initial activities
         * @param {ConnectStravaDto} connectStravaDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerConnectStrava(connectStravaDto: ConnectStravaDto, options?: RawAxiosRequestConfig): AxiosPromise<StravaConnectionResponseDto> {
            return localVarFp.usersControllerConnectStrava(connectStravaDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete current user account (soft delete)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerDeleteAccount(options?: RawAxiosRequestConfig): AxiosPromise<UsersControllerDeleteAccount200Response> {
            return localVarFp.usersControllerDeleteAccount(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Disconnect user from Garmin (preserve existing activities)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerDisconnectGarmin(options?: RawAxiosRequestConfig): AxiosPromise<GarminDisconnectResponseDto> {
            return localVarFp.usersControllerDisconnectGarmin(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Disconnect user from Strava (preserve existing activities)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerDisconnectStrava(options?: RawAxiosRequestConfig): AxiosPromise<StravaDisconnectResponseDto> {
            return localVarFp.usersControllerDisconnectStrava(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get current authenticated user profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerGetCurrentUser(options?: RawAxiosRequestConfig): AxiosPromise<UserDto> {
            return localVarFp.usersControllerGetCurrentUser(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Garmin permissions for the current user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerGetGarminPermissions(options?: RawAxiosRequestConfig): AxiosPromise<GarminPermissionsResponseDto> {
            return localVarFp.usersControllerGetGarminPermissions(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Garmin webhook for user permission changes
         * @param {GarminWebhookPermissionsDto} garminWebhookPermissionsDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerHandleGarminPermissionsWebhook(garminWebhookPermissionsDto: GarminWebhookPermissionsDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.usersControllerHandleGarminPermissionsWebhook(garminWebhookPermissionsDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Garmin ping verification for user dereg webhook
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerHandleGarminUserDeregPing(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.usersControllerHandleGarminUserDeregPing(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Garmin webhook for user deregistration
         * @param {GarminWebhookUserDeregDto} garminWebhookUserDeregDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerHandleGarminUserDeregWebhook(garminWebhookUserDeregDto: GarminWebhookUserDeregDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.usersControllerHandleGarminUserDeregWebhook(garminWebhookUserDeregDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Register FCM token for push notifications
         * @param {RegisterFcmTokenDto} registerFcmTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerRegisterFcmToken(registerFcmTokenDto: RegisterFcmTokenDto, options?: RawAxiosRequestConfig): AxiosPromise<UserDto> {
            return localVarFp.usersControllerRegisterFcmToken(registerFcmTokenDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Remove FCM token from user
         * @param {RemoveFcmTokenDto} removeFcmTokenDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerRemoveFcmToken(removeFcmTokenDto: RemoveFcmTokenDto, options?: RawAxiosRequestConfig): AxiosPromise<UserDto> {
            return localVarFp.usersControllerRemoveFcmToken(removeFcmTokenDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sync Apple Health activities from client-provided workout samples
         * @param {SyncAppleHealthActivitiesDto} syncAppleHealthActivitiesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerSyncAppleHealthActivities(syncAppleHealthActivitiesDto: SyncAppleHealthActivitiesDto, options?: RawAxiosRequestConfig): AxiosPromise<AppleHealthSyncResponseDto> {
            return localVarFp.usersControllerSyncAppleHealthActivities(syncAppleHealthActivitiesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Manually sync Garmin activities
         * @param {SyncGarminActivitiesDto} syncGarminActivitiesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerSyncGarminActivities(syncGarminActivitiesDto: SyncGarminActivitiesDto, options?: RawAxiosRequestConfig): AxiosPromise<GarminSyncResponseDto> {
            return localVarFp.usersControllerSyncGarminActivities(syncGarminActivitiesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Manually sync Strava activities
         * @param {SyncStravaActivitiesDto} syncStravaActivitiesDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerSyncStravaActivities(syncStravaActivitiesDto: SyncStravaActivitiesDto, options?: RawAxiosRequestConfig): AxiosPromise<StravaSyncResponseDto> {
            return localVarFp.usersControllerSyncStravaActivities(syncStravaActivitiesDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update user by ID
         * @param {UpdateUserDto} updateUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        usersControllerUpdate(updateUserDto: UpdateUserDto, options?: RawAxiosRequestConfig): AxiosPromise<UserDto> {
            return localVarFp.usersControllerUpdate(updateUserDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UsersApi - object-oriented interface
 * @export
 * @class UsersApi
 * @extends {BaseAPI}
 */
export class UsersApi extends BaseAPI {
    /**
     * 
     * @summary Connect user to Garmin and sync initial activities
     * @param {ConnectGarminDto} connectGarminDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersControllerConnectGarmin(connectGarminDto: ConnectGarminDto, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersControllerConnectGarmin(connectGarminDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Connect user to Strava and sync initial activities
     * @param {ConnectStravaDto} connectStravaDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersControllerConnectStrava(connectStravaDto: ConnectStravaDto, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersControllerConnectStrava(connectStravaDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete current user account (soft delete)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersControllerDeleteAccount(options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersControllerDeleteAccount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Disconnect user from Garmin (preserve existing activities)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersControllerDisconnectGarmin(options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersControllerDisconnectGarmin(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Disconnect user from Strava (preserve existing activities)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersControllerDisconnectStrava(options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersControllerDisconnectStrava(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get current authenticated user profile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersControllerGetCurrentUser(options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersControllerGetCurrentUser(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Garmin permissions for the current user
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersControllerGetGarminPermissions(options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersControllerGetGarminPermissions(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Garmin webhook for user permission changes
     * @param {GarminWebhookPermissionsDto} garminWebhookPermissionsDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersControllerHandleGarminPermissionsWebhook(garminWebhookPermissionsDto: GarminWebhookPermissionsDto, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersControllerHandleGarminPermissionsWebhook(garminWebhookPermissionsDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Garmin ping verification for user dereg webhook
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersControllerHandleGarminUserDeregPing(options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersControllerHandleGarminUserDeregPing(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Garmin webhook for user deregistration
     * @param {GarminWebhookUserDeregDto} garminWebhookUserDeregDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersControllerHandleGarminUserDeregWebhook(garminWebhookUserDeregDto: GarminWebhookUserDeregDto, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersControllerHandleGarminUserDeregWebhook(garminWebhookUserDeregDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Register FCM token for push notifications
     * @param {RegisterFcmTokenDto} registerFcmTokenDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersControllerRegisterFcmToken(registerFcmTokenDto: RegisterFcmTokenDto, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersControllerRegisterFcmToken(registerFcmTokenDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Remove FCM token from user
     * @param {RemoveFcmTokenDto} removeFcmTokenDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersControllerRemoveFcmToken(removeFcmTokenDto: RemoveFcmTokenDto, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersControllerRemoveFcmToken(removeFcmTokenDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sync Apple Health activities from client-provided workout samples
     * @param {SyncAppleHealthActivitiesDto} syncAppleHealthActivitiesDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersControllerSyncAppleHealthActivities(syncAppleHealthActivitiesDto: SyncAppleHealthActivitiesDto, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersControllerSyncAppleHealthActivities(syncAppleHealthActivitiesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Manually sync Garmin activities
     * @param {SyncGarminActivitiesDto} syncGarminActivitiesDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersControllerSyncGarminActivities(syncGarminActivitiesDto: SyncGarminActivitiesDto, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersControllerSyncGarminActivities(syncGarminActivitiesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Manually sync Strava activities
     * @param {SyncStravaActivitiesDto} syncStravaActivitiesDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersControllerSyncStravaActivities(syncStravaActivitiesDto: SyncStravaActivitiesDto, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersControllerSyncStravaActivities(syncStravaActivitiesDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update user by ID
     * @param {UpdateUserDto} updateUserDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersApi
     */
    public usersControllerUpdate(updateUserDto: UpdateUserDto, options?: RawAxiosRequestConfig) {
        return UsersApiFp(this.configuration).usersControllerUpdate(updateUserDto, options).then((request) => request(this.axios, this.basePath));
    }
}

